









































































































import { Component, Vue } from 'vue-property-decorator';
import { getTaxRoundTypes, getTaxRoundTypeName, TaxRoundTypes } from '@/enums/taxRoundTypes';
import { getTaxTypes, getTaxTypeName, TaxTypes } from '@/enums/taxTypes';
import { BillSettingRequest } from '@/models/billSettingRequest';
import { BillSettingResponse } from '@/models/billSettingResponse';
import Axios from 'axios';
import AvaivaledVue from '@/components/avaivaled.vue';
import { FunctionTypes } from '@/enums/functionTypes';

@Component({})
export default class BillSettings extends AvaivaledVue {
  public getTaxRoundTypes = getTaxRoundTypes;
  public getTaxRoundTypeName = getTaxRoundTypeName;
  public getTaxTypes = getTaxTypes;
  public getTaxTypeName = getTaxTypeName;

  private billSetting: BillSettingResponse = {
    taxType: TaxTypes.External,
    taxRoundType: TaxRoundTypes.HalfUp,
    automaticCreation: false,
    automaticCreationDay: 1,
    automaticCreationHour: 0,
    automaticCharge: false,
    automaticChargeHour: 0,
  };

  private async created() {
    const ok = await this.pageBackCheck(FunctionTypes.Bill);
    if (!ok) {
      return;
    }

    try {
      const res = await Axios.get<BillSettingResponse>('/api/bill-settings/bill');
      this.billSetting = res.data;
    } catch (error) {
      this.$router.push('/');
    }
  }

  private deactivated() {
    this.$destroy();
  }

  private async onRegister() {
    try {
      await Axios.put('/api/bill-settings/bill', {
        ...this.billSetting
      } as BillSettingRequest);
      this.$notify.success({
        title: '請求設定登録',
        message: '請求設定を登録しました。',
        position: 'bottom-right'
      });
    } catch (error) {
      this.$notify.error({
        title: '請求設定登録',
        message: '請求設定の登録が失敗しました。',
        position: 'bottom-right'
      });
    }
  }
}
